export const environment = {
    production: false,
    appVersion: require('../../package.json').version + '-demo',
    appTitle: "BestLevelSupport Helpdesk by MVIP",
    appLogoPath : "assets\\Wortmarkekomplett.svg",
    appFavicon : "assets\\faviconente.ico",
    appLogoFavicon : "assets\\favicondemo.ico",
    appFavicongif :"assets\\favicon1.gif",
    pCC_loginissue_Frontend: "https://help.bestlevel.support",
    tCCTicketFrontend: "https://support.bestlevel.support",
    tCCTicketServer: "https://ticket.bestlevel.support",
    TicketAuthorisation: "https://authorisation.bestlevel.support"

};
